import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import React from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  // Attach scroll listener only once – useEffect is the proper hook for side‑effects
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    // Initialise the state based on the current scroll position
    handleScroll();

    window.addEventListener('scroll', handleScroll);
    // Cleanup on unmount
    return () => window.removeEventListener('scroll', handleScroll);
  }, []); // empty dependency array → runs once

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex flex-col">
            <Link to="/" className="flex items-center gap-3 cursor-pointer">
              <div className="w-10 h-10 bg-teal-600 rounded-lg flex items-center justify-center">
                <i className="ri-robot-2-line text-white text-xl"></i>
              </div>
              <span
                className={`text-2xl font-bold transition-colors ${
                  isScrolled ? 'text-gray-900' : 'text-white'
                }`}
              >
                Automigo
              </span>
            </Link>
            <span
              className={`text-xs ml-14 transition-colors ${
                isScrolled ? 'text-gray-600' : 'text-white/80'
              }`}
            >
              Serving Long Island Businesses
            </span>
          </div>

          {/* Navigation Links */}
          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white/90 hover:text-white'
              }`}
            >
              Home
            </Link>
            <Link
              to="/how-it-works"
              className={`text-sm font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white/90 hover:text-white'
              }`}
            >
              How It Works
            </Link>
            <Link
              to="/who-its-for"
              className={`text-sm font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white/90 hover:text-white'
              }`}
            >
              Who It&apos;s For
            </Link>
            <Link
              to="/about-us"
              className={`text-sm font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white/90 hover:text-white'
              }`}
            >
              About
            </Link>
            <Link
              to="/get-started"
              className="bg-teal-600 hover:bg-teal-700 text-white text-sm font-semibold px-5 py-2.5 rounded-md transition-colors cursor-pointer whitespace-nowrap"
            >
              Get Started
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
